/**
 * Central application configuration — the single source of truth for the
 * Pearl - EnergyFlow web portal name, version, build number, release date,
 * and copyright strings. Mirrors mobile `frontend/src/config/app.ts` on the
 * feature/sync-master branch so both platforms stay in lockstep.
 * Bump `version`, `buildNumber`, and `releaseDate` here on every release.
 *
 * DEV-012C · Product naming taxonomy:
 *   • "Pearl - EnergyFlow" — the customer-facing application/product
 *   • "EnergyFlow"         — the underlying software platform/technology
 *   • "Pearl Energy"       — the solar installation company
 *   • "SolarFlow"          — obsolete product name (internal identifiers only)
 */
import { installerBranding } from "@/branding/Branding";

export const appConfig = {
    name: "Pearl - EnergyFlow",
    tagline: "Your Solar Installation Journey",
    version: "1.0.0",
    buildNumber: "100",
    releaseDate: "February 2026",
    copyrightOwner: "Kevin Cooper",
    copyrightYear: 2026,
    copyrightNotice:
        "Pearl - EnergyFlow is powered by EnergyFlow, proprietary software developed and owned by Kevin Cooper. " +
        "No part of this application may be copied, reproduced, modified or distributed " +
        "without the express written permission of the copyright owner.",
    installer: installerBranding,
};

export const copyrightLine = () =>
    `© ${appConfig.copyrightYear} ${appConfig.copyrightOwner}. All rights reserved.`;

export const versionLine = () => `Version ${appConfig.version}`;
